import { getPostActionString } from '~/post/helpers';
import { RpcUpdate } from '~/post/types';
import { selectProfileTimezone } from '~/profile-sidebar/selectors';
import { getDateString } from '~/server/formatters';
import { useAppSelector } from '~/store';
import {
  selectHasTwentyFourHourTimeFormat,
  selectUserId,
} from '~/user/selectors';

export const useDraftDetails = (draft: RpcUpdate) => {
  if (!draft)
    return { postAction: '', avatarUrl: '', creatorName: '', createdAt: '' };

  const servicesWithCommentFeature = ['instagram'];
  const userId = useAppSelector(selectUserId);
  const profileId = draft?.profileId;
  const createdAt = draft?.createdAt;
  const profileTimezone: string | null = useAppSelector((state) =>
    selectProfileTimezone(state, profileId)
  );
  const twentyFourHourTime: boolean = useAppSelector(
    selectHasTwentyFourHourTimeFormat
  );

  const createdAtString = getDateString(createdAt, profileTimezone, {
    createdAt,
    twentyFourHourTime,
  });
  const avatarUrl = draft?.user?.avatar ?? draft?.user?.gravatar;

  return {
    draftId: draft.id,
    creatorName: draft.user?.id === userId ? 'You' : draft.user?.name ?? '',
    email: draft.user ? draft.user.email : '',
    avatarUrl,
    createdAt: createdAtString,
    postAction: getPostActionString({
      post: draft,
      profileTimezone,
      twentyFourHourTime,
    }),
    isRetweet: draft.retweet !== undefined,
    commentText: draft.commentText,
    hasCommentEnabled:
      servicesWithCommentFeature.indexOf(draft.profile_service) !== -1,
    shopgridLink: draft.shopgridLink,
    channel: draft.headerDetails?.channel,
  };
};
